import { SwiperProps } from 'swiper/react'
import { NavigationOptions } from 'swiper/types'

// this method is similar what swiperjs has (https://github.com/nolimits4web/swiper/blob/master/src/react/utils.js#L25)
// uses to determine if we need the navigation or it will be handled outside
export function needsNavigation(params: SwiperProps = {}): boolean {
  return (
    !!params.navigation &&
    typeof (params.navigation as NavigationOptions).nextEl === 'undefined' &&
    typeof (params.navigation as NavigationOptions).prevEl === 'undefined'
  )
}
